import React from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { modalBoxStyle } from "../styles";

var moment = require("moment");

const WasteLogDeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  wasteLog,
  isDeleting,
}) => {
  const productDisplay = wasteLog?.productName || "Unknown Product";
  const dateDisplay = wasteLog?.wasteDate
    ? moment(wasteLog.wasteDate).format("MMMM Do, YYYY")
    : "Unknown Date";

  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="delete-waste-log-modal">
      <Box sx={{ ...modalBoxStyle, width: { xs: "320px", md: "450px" }, maxWidth: { xs: "320px !important", md: "450px !important" } }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <Typography variant="h5">Delete Waste Log</Typography>
          <IconButton onClick={onClose}>
            <CloseOutlinedIcon />
          </IconButton>
        </Box>

        {/* Message */}
        <Typography variant="body1" sx={{ marginBottom: 6 }}>
          Are you sure you want to delete the waste log for &ldquo;{productDisplay}&rdquo; on {dateDisplay}?
        </Typography>

        {/* Buttons */}
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isDeleting}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={isDeleting}
            sx={{ textTransform: "none" }}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default WasteLogDeleteConfirmationModal;
